import { TypeOf, yup } from '@guiker/yup-util'

export const requestContributionResplitSchema = yup.object({
  amount: yup.number().required(),
})

export type RequestContributionResplitSchema = TypeOf<typeof requestContributionResplitSchema>
